import {
  POST_COMMENT_SUCCESS,
  POST_REPLY_SUCCESS,
  EDIT_PARENT_SUCCESS,
  EDIT_CHILD_SUCCESS,
  LIKE_COMMENT_SUCCESS,
  LIKE_CHILD_COMMENT_SUCCESS,
  DELETE_COMMENT_SUCCESS,
  DELETE_REPLY_SUCCESS,
  REPORT_COMMENT_SUCCESS,
  REPORT_REPLY_SUCCESS
} from '../../store/actions/comments/commentsActions';
import * as AnalyticsConstants from './analyticsConstants';
import {
  getComment,
  getCommentChild
} from '../../store/selectors/comments/commentsSelectors';
import { TOGGLE_REPLIES } from '../../store/actions/ui/uiActions';

const analyticsConfig = {
  [TOGGLE_REPLIES]: {
    eventName: AnalyticsConstants.VIEW_REPLIES,
    getProps: (store, action) => {
      const {
        payload: { contentId, communityId, showingReplies, numberOfReplies }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: contentId,
        [AnalyticsConstants.COMMUNITY_ID]: communityId,
        [AnalyticsConstants.SHOWING_REPLIES]: showingReplies,
        [AnalyticsConstants.NUMBER_OF_REPLIES]: numberOfReplies
      };
    }
  },
  [POST_COMMENT_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT,
    getProps: (store, action) => {
      const {
        payload: { comment }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Parent',
        [AnalyticsConstants.NUMBER_OF_MENTIONS]: comment.mentioned_users.length,
        [AnalyticsConstants.MENTIONED_USER_IDS]: comment.mentioned_users.map(
          (user) => user.id
        ),
        [AnalyticsConstants.CHARACTER_LENGTH]: comment.body.length,
        [AnalyticsConstants.EDIT_COMMENT]: false
      };
    }
  },
  [POST_REPLY_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT,
    getProps: (store, action) => {
      const {
        payload: { reply }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: reply.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: reply.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Reply',
        [AnalyticsConstants.NUMBER_OF_MENTIONS]: reply.mentioned_users.length,
        [AnalyticsConstants.MENTIONED_USER_IDS]: reply.mentioned_users.map(
          (user) => user.id
        ),
        [AnalyticsConstants.CHARACTER_LENGTH]: reply.body.length,
        [AnalyticsConstants.EDIT_COMMENT]: false
      };
    }
  },
  [EDIT_PARENT_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT,
    getProps: (store, action) => {
      const {
        payload: { comment }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Parent',
        [AnalyticsConstants.NUMBER_OF_MENTIONS]: comment.mentioned_users.length,
        [AnalyticsConstants.MENTIONED_USER_IDS]: comment.mentioned_users.map(
          (user) => user.id
        ),
        [AnalyticsConstants.CHARACTER_LENGTH]: comment.body.length,
        [AnalyticsConstants.EDIT_COMMENT]: true
      };
    }
  },
  [EDIT_CHILD_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT,
    getProps: (store, action) => {
      const {
        payload: { comment }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Reply',
        [AnalyticsConstants.NUMBER_OF_MENTIONS]: comment.mentioned_users.length,
        [AnalyticsConstants.MENTIONED_USER_IDS]: comment.mentioned_users.map(
          (user) => user.id
        ),
        [AnalyticsConstants.CHARACTER_LENGTH]: comment.body.length,
        [AnalyticsConstants.EDIT_COMMENT]: true
      };
    }
  },
  [LIKE_COMMENT_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT_LIKE,
    getProps: (store, action) => {
      const {
        payload: { commentId }
      } = action;
      const comment = getComment(store.getState(), commentId);
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Parent'
      };
    }
  },
  [LIKE_CHILD_COMMENT_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT_LIKE,
    getProps: (store, action) => {
      const {
        payload: { parentId, commentId }
      } = action;
      const comment = getCommentChild(store.getState(), parentId, commentId);
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Reply'
      };
    }
  },
  [DELETE_COMMENT_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT_DELETE,
    getProps: (store, action) => {
      const {
        payload: { comment }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.context_community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Parent'
      };
    }
  },
  [DELETE_REPLY_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT_DELETE,
    getProps: (store, action) => {
      const {
        payload: { reply }
      } = action;
      return {
        [AnalyticsConstants.CONTENT_ID]: reply.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: reply.context_community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Reply'
      };
    }
  },
  [REPORT_COMMENT_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT_REPORT,
    getProps: (store, action) => {
      const {
        payload: { commentId }
      } = action;
      const comment = getComment(store.getState(), commentId);
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Parent'
      };
    }
  },
  [REPORT_REPLY_SUCCESS]: {
    eventName: AnalyticsConstants.COMMENT_REPORT,
    getProps: (store, action) => {
      const {
        payload: { commentId, rootId }
      } = action;
      const comment = getCommentChild(store.getState(), rootId, commentId);
      return {
        [AnalyticsConstants.CONTENT_ID]: comment.content_id,
        [AnalyticsConstants.COMMUNITY_ID]: comment.community_id,
        [AnalyticsConstants.COMMENT_TYPE]: 'Reply'
      };
    }
  }
};

export default analyticsConfig;
